import script from "./SlippageSelector.vue?vue&type=script&lang=ts&setup=true"
export * from "./SlippageSelector.vue?vue&type=script&lang=ts&setup=true"

import "./SlippageSelector.vue?vue&type=style&index=0&id=d72b59ca&lang=css"

const __exports__ = script;

export default __exports__